module.exports = __webpack_public_path__ + "static/img/advert_2.14c3287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SharePrinting/advert_2.png
// module id = 6An9
// module chunks = 10